let newDate = new Date();
newDate.setDate(newDate.getDate() - 1);

export default {
  loading: false,
  error: '',
  status: {
    message: '',
    warning: false
  },
  login: {
    login: false,
    name: '',
    email: '',
    password: ''
  },
  user: {
    _id: '',
    name: '',
    email: '',
    started: new Date(),
    last: newDate,
    longestStreak: 0,
    streak: 0,
    score: 0,
    created: [],
    answered: []
  },
  editUser: {
    name: '',
    email: ''
  },
  answer: {
    _id: '',
    user_id: '',
    user_name: '',
    prompt_id: '',
    prompt_title: '',
    answered: new Date(),
    modified: new Date(),
    text: '',
    type: 'paragraph',
    categories: []
  },
  category: '',
  search: '',
  newPrompt: {
    title: '',
    type: 'paragraph',
    categories: []
  },
  todayPrompt: '',
  todayPromptDate: newDate,
  prompts: [],
  myPrompts: [],
  submittedPrompts: [],
  editPrompts: [],
  editPrompt: {
    _id: '',
    user_id: '',
    user_name: '',
    title: '',
    type: 'paragraph',
    categories: []
  },
  newAdminPrompt: {
    _id: '',
    user_id: '',
    user_name: '',
    title: '',
    type: 'paragraph',
    categories: []
  },
  admin: [],
  newAdmin: '',
  answers: [],
  seen: {
    today: new Date(),
    prompts: []
  },
  categories: ['Gratitude', 'Growth', 'Life', 'Quotes', 'Self', 'Today', 'Work'], // love, religion, spirit, soul
  offline: {
    beenOffline: false,
    answered: [],
    created: [],
    streak: 0,
    longestStreak: 0,
    score: 0,
    last: null,
    deleted: [],
  },
  otherUser: {
    sharedAnswers: []
  },
  sideMenu: false,
  world: {
    loading: false,
    page: 1,
    sharedAnswers: []
  },
  ids: {
    answerId: '',
    userAnswerId: '',
    worldAnswerId: ''
  },
  data: {
    answers: [],
    users: [],
    prompts: []
  },
  reportedAnswers: [],
};
